module.exports = __webpack_public_path__ + "img/action-close.5d2046d2.svg";